import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { ZfIcon, ZfStack, ZfTypography } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import type { TalkingPointDto } from '../../../api/generated/client';

interface IProps {
    point: TalkingPointDto;
}

export const AdminTopicSortableItem: FunctionComponent<IProps> = ({ point }) => {
    const { i18n } = useTranslation();

    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: point.id });

    return (
        <div ref={setNodeRef} style={{ transform: CSS.Transform.toString(transform), transition }} {...attributes} {...listeners}>
            <ZfStack
                direction="row"
                alignment="center"
                justify="space-between"
                className="talking-point-sort-list-item"
                style={{ cursor: isDragging ? 'grabbing' : 'grab' }}
            >
                <ZfTypography variant="body-medium">{point.name[i18n.language]}</ZfTypography>
                <ZfIcon name="drag_indicator" />
            </ZfStack>
        </div>
    );
};
